import { Box, FormHelperText, Grid, Typography } from '@mui/material';
import { error, selectedButton } from '../../../../assets/styles/appStyles';
import AppTimePicker from '../AppTimePicker';
import GenericSelectInput from '../UI/GenericSelectInput';
import { useEffect, useState } from 'react';

export default function DepartmentServeInfoDay({
  form,
  timeZones,
  days,
  day,
  dayIndex,
  handServeId,
}: {
  form: any;
  timeZones: any[];
  days: any[];
  day: any;
  dayIndex: number;
  handServeId: string;
}) {
  const dayItemHourErrorMessage = (
    hourKeyName: string,
    hourLevelKeyName: string,
    index: number,
  ) => {
    return form.errors.custodianDetails &&
      form.errors.custodianDetails.daysAvailable &&
      form.errors.custodianDetails.daysAvailable[index] &&
      form.errors.custodianDetails.daysAvailable[index][
      hourKeyName
      ] &&
      form.errors.custodianDetails.daysAvailable[index][
      hourKeyName
      ][hourLevelKeyName]
      ? form.errors.custodianDetails.daysAvailable[index][
      hourKeyName
      ][hourLevelKeyName]
      : '';
  };

  const [openPickerId, setOpenPickerId] = useState<string>('');

  return (
    <Grid container key={day.dayOfWeek} spacing={2} mt={4}>
      <Grid item xs={1} mt={4}>
        <Typography sx={selectedButton}>
          {days.find((d) => d.id.toString() == day.dayOfWeek)?.name}
        </Typography>
      </Grid>

      <Grid item xs={3}>
        <Grid container>
          <Grid item xs={12}>
            <Typography align="left">Serve Hours</Typography>
          </Grid>
          <Grid item xs={12} pt={1}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <AppTimePicker
                  close={openPickerId !== 'serveHoursFrom'}
                  onOpenHandler={() => setOpenPickerId('serveHoursFrom')}
                  disabled={
                    form.values.custodianDetails.serveMethods.findIndex(
                      (s: { serveMethodId: string; }) => s.serveMethodId == handServeId,
                    ) === -1
                  }
                  keyName={`custodianDetails.daysAvailable.${dayIndex}.serveHours.from`}
                  label="Serve Hours"
                  fieldLabel="From"
                  errorMsg={''}
                  onChange={(value) => {
                    form.setFieldValue(
                      `custodianDetails.daysAvailable.${dayIndex}.serveHours.from`,
                      value,
                    );
                  }}
                  value={form.values.custodianDetails.daysAvailable[dayIndex].serveHours.from}
                />
              </Grid>
              <Grid item xs={6}>
                <AppTimePicker
                  close={openPickerId !== 'serveHoursTo'}
                  onOpenHandler={() => setOpenPickerId('serveHoursTo')}
                  disabled={
                    form.values.custodianDetails.serveMethods.findIndex(
                      (s: { serveMethodId: string; }) => s.serveMethodId == handServeId,
                    ) === -1
                  }
                  keyName={`custodianDetails.daysAvailable.${dayIndex}.serveHours.to`}
                  label="Serve Hours"
                  fieldLabel="To"
                  errorMsg={''}
                  onChange={(value) => {
                    form.setFieldValue(
                      `custodianDetails.daysAvailable.${dayIndex}.serveHours.to`,
                      value,
                    );
                  }}
                  value={form.values.custodianDetails.daysAvailable[dayIndex].serveHours.to}
                />
              </Grid>
              {dayItemHourErrorMessage('serveHours', 'from', dayIndex) && (
                <Grid item xs={12} pl={1}>
                  <FormHelperText sx={error}>
                    {dayItemHourErrorMessage('serveHours', 'from', dayIndex)}
                  </FormHelperText>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={3}>
        <Grid container>
          <Grid item xs={12}>
            <Typography align="left">Pick up and copy hours</Typography>
          </Grid>
          <Grid item xs={12} pt={1}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <AppTimePicker
                  close={openPickerId !== 'pickupAndCopyHoursFrom'}
                  onOpenHandler={() =>
                    setOpenPickerId('pickupAndCopyHoursFrom')
                  }
                  disabled={
                    form.values.custodianDetails.serveMethods.findIndex(
                      (s: { serveMethodId: string; }) => s.serveMethodId == handServeId,
                    ) === -1
                  }
                  keyName={`custodianDetails.daysAvailable.${dayIndex}.pickupAndCopyHours.from`}
                  label="Pick up and copy hours"
                  fieldLabel="From"
                  errorMsg={''}
                  onChange={(value) => {
                    form.setFieldValue(
                      `custodianDetails.daysAvailable.${dayIndex}.pickupAndCopyHours.from`,
                      value,
                    );
                  }}
                  value={form.values.custodianDetails.daysAvailable[dayIndex].pickupAndCopyHours.from}
                />
              </Grid>
              <Grid item xs={6}>
                <AppTimePicker
                  close={openPickerId !== 'pickupAndCopyHoursTo'}
                  onOpenHandler={() => setOpenPickerId('pickupAndCopyHoursTo')}
                  disabled={
                    form.values.custodianDetails.serveMethods.findIndex(
                      (s: { serveMethodId: string; }) => s.serveMethodId == handServeId,
                    ) === -1
                  }
                  keyName={`custodianDetails.daysAvailable.${dayIndex}.pickupAndCopyHours.to`}
                  label="Pick up and copy hours"
                  fieldLabel="To"
                  errorMsg={''}
                  onChange={(value) => {
                    form.setFieldValue(
                      `custodianDetails.daysAvailable.${dayIndex}.pickupAndCopyHours.to`,
                      value,
                    );
                  }}
                  value={form.values.custodianDetails.daysAvailable[dayIndex].pickupAndCopyHours.to}
                />
              </Grid>
              {dayItemHourErrorMessage(
                'pickupAndCopyHours',
                'from',
                dayIndex,
              ) && (
                  <Grid item xs={12} pl={1}>
                    <FormHelperText sx={error}>
                      {dayItemHourErrorMessage(
                        'pickupAndCopyHours',
                        'from',
                        dayIndex,
                      )}
                    </FormHelperText>
                  </Grid>
                )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={3}>
        <Grid container>
          <Grid item xs={12}>
            <Typography align="left">Best time to call</Typography>
          </Grid>
          <Grid item xs={12} pt={1}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <AppTimePicker
                  close={openPickerId !== 'bestTimeToCallFrom'}
                  onOpenHandler={() => setOpenPickerId('bestTimeToCallFrom')}
                  keyName={`custodianDetails.daysAvailable.${dayIndex}.bestTimeToCall.from`}
                  label="Best time to call"
                  fieldLabel="From"
                  errorMsg={''}
                  onChange={(value) => {
                    form.setFieldValue(
                      `custodianDetails.daysAvailable.${dayIndex}.bestTimeToCall.from`,
                      value,
                    );
                  }}
                  value={form.values.custodianDetails.daysAvailable[dayIndex].bestTimeToCall.from}
                />
              </Grid>
              <Grid item xs={6}>
                <AppTimePicker
                  close={openPickerId !== 'bestTimeToCallTo'}
                  onOpenHandler={() => setOpenPickerId('bestTimeToCallTo')}
                  keyName={`custodianDetails.daysAvailable.${dayIndex}.bestTimeToCall.to`}
                  label="Best time to call"
                  fieldLabel="To"
                  errorMsg={''}
                  onChange={(value) => {
                    form.setFieldValue(
                      `custodianDetails.daysAvailable.${dayIndex}.bestTimeToCall.to`,
                      value,
                    );
                  }}
                  value={form.values.custodianDetails.daysAvailable[dayIndex].bestTimeToCall.to}
                />
              </Grid>
              {dayItemHourErrorMessage('bestTimeToCall', 'from', dayIndex) && (
                <Grid item xs={12} pl={1}>
                  <FormHelperText sx={error}>
                    {dayItemHourErrorMessage(
                      'bestTimeToCall',
                      'from',
                      dayIndex,
                    )}
                  </FormHelperText>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={2}>
        <Grid item xs={12}>
          <Typography align="left">Timezone</Typography>
        </Grid>
        <Box pt={1}>
          <GenericSelectInput
            name={`custodianDetails.daysAvailable.${dayIndex}.timeZoneId`}
            label="Timezone"
            value={form.values.custodianDetails.daysAvailable[dayIndex].timeZoneId ?? ''}
            onChange={(e: string) => {
              form.setFieldValue(
                `custodianDetails.daysAvailable.${dayIndex}.timeZoneId`,
                e,
              );
            }}
            errorMsg={''}
            hasError={false}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.daysAvailable.${dayIndex}.timeZoneId`,
                true,
              );
            }}
            options={timeZones}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
